<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    class="w-6 h-6"
  >
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="2"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M6 14l2-2 3 3 4-4 3 3"
    />
    <path stroke-width="2" stroke-linecap="round" d="M6 9h6" />
  </svg>
</template>

<script>
export default {
  name: "BannerIcon"
}
</script>

<style scoped>
svg {
  display: block;
  color: currentColor;
}
</style>
